export const SET_GRAPHOVERVIEWFILTERS = 'SET_GRAPHOVERVIEWFILTERS';
export const SET_PROJECTOVERVIEWFILTERS = 'SET_PROJECTOVERVIEWFILTERS';

export const RESET_ACTIVEFILTERS = 'RESET_ACTIVEFILTERS';